"use client";

import {
  FileText,
  Video,
  Download,
  Upload,
  Eye,
  RefreshCcw,
  CheckCircle2,
  ShieldCheck,
} from "lucide-react";

export default function Documents() {
  const previewResume = () => {
    window.open("/resume/Rahul_Sharma_Resume.pdf", "_blank");
  };

  const downloadResume = () => {
    const link = document.createElement("a");
    link.href = "/resume/Rahul_Sharma_Resume.pdf";
    link.download = "Rahul_Sharma_Resume.pdf";
    link.click();
  };

  const uploadDocument = () => {
    alert("Upload Resume");
  };

  return (
    <div className="space-y-6">
      {/* HEADER */}
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Documents</h1>
        <p className="mt-1 text-sm text-slate-500">
          Manage your resume, video profile and verification documents.
        </p>
      </div>

      <div className="grid gap-5 lg:grid-cols-2">
        {/* RESUME CARD */}
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="flex justify-between">
            <div className="flex gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-100">
                <FileText size={20} className="text-blue-600" />
              </div>
              <div>
                <h2 className="font-bold">Resume</h2>
                <p className="text-xs text-slate-500">Latest Resume</p>
              </div>
            </div>
            <CheckCircle2 size={20} className="text-green-600" />
          </div>

          <div className="mt-5 rounded-xl border border-dashed p-4">
            <h3 className="text-sm font-semibold">Rahul_Sharma_Resume.pdf</h3>
            <p className="mt-1 text-xs text-slate-500">PDF • 2.4 MB</p>

            <div className="mt-4 flex gap-2">
              <button
                onClick={previewResume}
                className="flex items-center gap-2 rounded-lg border px-3 py-2 text-xs font-semibold hover:bg-slate-50 transition"
              >
                <Eye size={14} />
                Preview
              </button>

              <button
                onClick={downloadResume}
                className="flex items-center gap-2 rounded-lg border px-3 py-2 text-xs font-semibold hover:bg-slate-50 transition"
              >
                <Download size={14} />
                Download
              </button>
            </div>
          </div>

          <button
            onClick={uploadDocument}
            className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 transition"
          >
            <RefreshCcw size={15} />
            Replace Resume
          </button>
        </div>

        {/* VIDEO PROFILE CARD */}
        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
          <div className="flex justify-between">
            <div className="flex gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-purple-100">
                <Video size={20} className="text-purple-600" />
              </div>
              <div>
                <h2 className="font-bold">Introduction Video</h2>
                <p className="text-xs text-slate-500">Video Profile</p>
              </div>
            </div>
            <CheckCircle2 size={20} className="text-green-600" />
          </div>

          <div className="mt-5 flex h-36 items-center justify-center rounded-xl bg-slate-100">
            <Video size={35} className="text-purple-600" />
          </div>

          <div className="mt-4 flex gap-2">
            <button className="flex items-center gap-2 rounded-lg border px-3 py-2 text-xs font-semibold hover:bg-slate-50 transition">
              <Eye size={14} />
              Preview
            </button>

            <button
              onClick={uploadDocument}
              className="flex items-center gap-2 rounded-lg bg-purple-600 px-3 py-2 text-xs font-semibold text-white hover:bg-purple-700 transition"
            >
              <Upload size={14} />
              Replace
            </button>
          </div>
        </div>
      </div>

      {/* VERIFICATION STATUS */}
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex items-center gap-2">
          <ShieldCheck size={20} className="text-blue-600" />
          <h2 className="font-bold">Verification Status</h2>
        </div>

        <div className="mt-4 grid gap-4 md:grid-cols-3">
          <StatusCard title="Resume Verified" desc="Recruiter Ready" />
          <StatusCard title="Video Verified" desc="Profile Completed" />
          <StatusCard title="ATS Ready" desc="Optimized" />
        </div>
      </div>
    </div>
  );
}

function StatusCard({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="rounded-xl bg-slate-50 p-4 border border-slate-100">
      <CheckCircle2 size={22} className="text-green-600" />
      <h3 className="mt-2 text-sm font-semibold text-slate-800">{title}</h3>
      <p className="text-xs text-slate-500">{desc}</p>
    </div>
  );
}